module.exports = __webpack_public_path__ + "media/colmedica_audio.daaf3f9f.mp3";